import { orderBy as _orderBy } from 'lodash-es';

interface IFirstLastName {
  firstName: string;
  lastName: string;
}

export function orderByFirstLastName<T extends IFirstLastName>(items: T[]): T[] {
  return _orderBy(items, [
    (item: T) => item.firstName.toLocaleLowerCase(),
    (item: T) => item.lastName.toLocaleLowerCase(),
  ], ['asc', 'asc']);
}
